// extracted by mini-css-extract-plugin
module.exports =  {"list":"BuildTypes__list--PO","item":"BuildTypes__item--UX","container":"BuildTypes__container--DP"};